import { Header } from "../components/Header";
import { OrderDocumentViewer } from "../components/OrderDocumentViewer";
import { useDriverOrderDocument, type DriverFetcher } from "../hooks";

export function OrderDocumentScreen({
  fetcher,
  stopPublicId,
  onBack,
}: {
  fetcher: DriverFetcher;
  stopPublicId: string;
  onBack: () => void;
}) {
  const { blobUrl, contentType, loading, error } = useDriverOrderDocument({
    ...fetcher,
    stopPublicId,
  });

  // 404 は「注文書未添付」を意味するため、生の HTTP エラーではなく分かりやすい文言にする。
  const isNotFound = error?.includes("404") ?? false;
  const message = isNotFound ? "この配送に注文書は登録されていません" : error;

  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Header title="注文書" sub={stopPublicId} showBack onBack={onBack} />

      {loading && (
        <div className="flex items-center justify-center py-12 text-[length:var(--fs-sm)] text-[var(--ink-3)]">
          読込中…
        </div>
      )}

      {error && !loading && (
        <div
          className={
            isNotFound
              ? "mx-2.5 mt-3 rounded-lg bg-[var(--bg-sunken)] px-3 py-2 text-[length:var(--fs-xs)] text-[var(--ink-3)]"
              : "mx-2.5 mt-3 rounded-lg bg-[var(--st-cancel-bg)] px-3 py-2 text-[length:var(--fs-xs)] text-[var(--st-cancel-ink)]"
          }
        >
          {isNotFound ? message : `⚠ ${message}`}
        </div>
      )}

      {!loading && !error && (
        <div className="h-[calc(100vh-56px)]">
          <OrderDocumentViewer blobUrl={blobUrl} contentType={contentType} />
        </div>
      )}
    </div>
  );
}
